/*
 * @Author: zhouwei
 * @Date: 2019-10-09 18:18:12
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-05-28 15:13:45
 * @Desc: 定时计划详情
*/
<template>
  <div class="plan-detail">
    <div
      class="go-back cursor"
      @click="cancel"
    >
      <mk-iconfont
        icon-class="left"
        class="icon"
      />
      <span>返回</span>
    </div>
    <div class="plan-tabs">
      <mk-tabs-biz
        v-model="activeName"
        class="el-tabs-mk-ui"
      >
        <mk-tab-pane
          v-for="(item,index) in navs"
          :key="index"
          :label="item.label"
          :name="item.name"
        >
        </mk-tab-pane>
      </mk-tabs-biz>
      <!-- <mk-button-biz
        width="64px"
        class="plan-back"
        @click="cancel"
      >
        返回
      </mk-button-biz> -->
    </div>
    <div class="content">
      <div class="detail">
        <div
          v-if="activeName === 'baseInfo'"
          class="detail-content base-info"
        >
          <mk-form
            class="form"
            label-width="90px"
          >
            <mk-form-item
              label="计划名称:"
              :rules="[{required: planStatus === 0 || planStatus === 1 ? true: false}]"
            >
              <mk-input
                v-if="planStatus === 0 || planStatus === 1"
                v-model="baseInfo.name"
                placeholder="请输入"
                width="320"
                maxlength="15"
                show-word-limit
              />
              <span v-else>{{ baseInfo.name }}</span>
            </mk-form-item>
            <mk-form-item
              label="计划时间:"
              :rules="[{required: planStatus === 0 || planStatus === 1 ? true: false}]"
            >
              <mk-date-picker
                v-if="planStatus === 0 || planStatus === 1"
                v-model="baseInfo.date"
                type="datetimerange"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                :picker-options="pickerOptions"
              />
              <div
                v-if="planStatus === 0 || planStatus === 1"
                class="tips"
              >
                * 请至少提前半小时创建定时计划
              </div>
              <span v-else>{{ baseInfo.startTime }} ~ {{ baseInfo.endTime }}</span>
            </mk-form-item>
            <mk-form-item label="计划状态:">
              <span :style="planStatus === 2 ? 'color: #3FC667;' : ''">{{ status }}</span>
            </mk-form-item>

            <mk-form-item label="执行成员:">
              <executive
                v-if="planStatus === 0 || planStatus === 1"
                v-model="baseInfo.executive"
                class="list-item-content"
                :init-person-arr="initPersonArr"
                :init-deper-arr="initDeperArr"
                @changeDepart="changeDepart"
                @changePerson="changePerson"
              ></executive>
              <div
                v-else
                class="list-item-content"
              >
                <template>
                  <div v-if="baseInfo.executive === '全体成员'">
                    全体成员
                  </div>
                  <div v-else>
                    <mk-tag
                      v-for="(item,index) in showTagsArr"
                      :key="index"
                      type="info"
                      style="margin-right:8px; font-size:13px;"
                    >
                      {{ item }}
                    </mk-tag>
                  </div>
                </template>
              </div>
            </mk-form-item>
            <mk-form-item label="备注:">
              <mk-input
                v-if="planStatus === 0 || planStatus === 1"
                v-model="baseInfo.remarks"
                type="textarea"
                class="textarea"
                placeholder="请输入"
                height="120"
                maxlength="140"
                show-word-limit
              >
              </mk-input>
              <span
                v-else
                class="remarks-info"
              >{{ baseInfo.remarks }}</span>
            </mk-form-item>
          </mk-form>
        </div>
        <div
          v-if="activeName === 'task'"
          class="detail-content marketing-data"
        >
          <div
            v-if="planStatus === 0 || planStatus === 1"
            class="add-marketing-data"
          >
            <mk-button-biz
              type="primary"
              icon="el-icon-plus"
              @click="addTask"
            >
              新增任务
            </mk-button-biz>
          </div>
          <div class="list">
            <mk-table
              :data="taskList"
            >
              <mk-table-column
                prop="index"
                label="序号"
                width="50"
              >
                <template v-slot="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </mk-table-column>
              <mk-table-column
                prop="showName"
                label="标题"
                min-width="200"
                show-overflow-tooltip
              >
              </mk-table-column>
              <mk-table-column
                label="标签"
                width="300"
              >
                <template v-slot="scope">
                  <tag-list-show-new
                    :tag-list="scope.row.showTags"
                    :limit="3"
                  />
                </template>
              </mk-table-column>
              <mk-table-column
                prop="materialType"
                label="分享类型"
                width="120"
              >
                <template v-slot="scope">
                  <div>
                    {{ getTxt(scope.row.materialType) }}
                  </div>
                </template>
              </mk-table-column>
              <mk-table-column
                prop="status"
                label="任务状态"
              >
                <template v-slot="scope">
                  <div
                    v-if="scope.row.status === 1"
                    style="color:rgb(63, 198, 103);"
                  >
                    {{ getStatusTxt(scope.row.status) }}
                  </div>
                  <div v-else>
                    {{ getStatusTxt(scope.row.status) }}
                  </div>
                </template>
              </mk-table-column>
              <mk-table-column
                prop="execTime"
                label="分享时间"
                width="160"
              >
              </mk-table-column>
              <mk-table-column
                v-if="planStatus === 0 || planStatus === 1"
                prop="handle"
                label="操作"
                width="100"
                fixed="right"
              >
                <template v-slot="scope">
                  <mk-button-biz
                    type="text"
                    @click="edit(scope.row._id,scope)"
                  >
                    编辑
                  </mk-button-biz>
                  <!-- v-if="taskList && taskList.length > 1" -->
                  <mk-button-biz
                    type="text"
                    @click="remove(scope.$index)"
                  >
                    移除
                  </mk-button-biz>
                </template>
              </mk-table-column>
            </mk-table>
          </div>
        </div>
        <template v-if="activeName === 'census'">
          <census :task-list="taskList"></census>
        </template>
      </div>
      <div
        v-if="planStatus === 0 || planStatus === 1"
        class="footer"
      >
        <mk-button-biz @click="save(false)">
          保存
        </mk-button-biz>
        <mk-button-biz
          v-if="planStatus === 0"
          type="primary"
          @click="savePublish"
        >
          保存并发布
        </mk-button-biz>
      </div>
      <material
        v-if="addMeansShow"
        :show="addMeansShow"
        :state="meansState"
        :date="baseInfo.date"
        :start-date="taskStartDate"
        :init-type="initType"
        :selected-id="selectedId"
        @cancel="handleListCancel"
        @add="addMaketingData"
        @replace="replaceMaketingData"
      />
    </div>
  </div>
</template>
<script>
import { BIZAPIS } from '@api'
import tagListShowNew from '@components/tag-list-show-new'
import executive from './components/executive.vue'
import material from './components/material.vue'
import dayjs from 'dayjs'
import census from './components/census/index.vue'
export default {
  name: 'PlanDetail',
  components: {
    executive,
    census,
    material,
    tagListShowNew
  },
  props: {
    state: {
      /**
       * state代表不同状态的值
       * 0: 未发布
       * 1: 未开始
       * 2: 进行中
       * 3: 已结束
       */
      type: [Number, String],
      default: 0
    },
    propData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      initType: '', // 编辑的type
      selectedId: '',
      meansInfoTitle: '文章标题', // 子任务选择标题
      meansInfoDefault: '请输入文章标题',
      showTagsArr: [],
      taskStartDate: '', // 任务开始时间
      pickerOptions: {
        // 日历选择限制30天
        // 第一次选择可能是开始，也有可能是结束;
        onPick: ({ maxDate, minDate }) => {
          this.pickerMinDate = minDate.getTime()
          if (maxDate) {
            this.pickerMinDate = ''
            this.pickerMaxDate = maxDate.getTime()
          }
        },
        disabledDate: time => {
          if (this.pickerMinDate !== '') {
            const day30 = (30 - 1) * 24 * 3600 * 1000
            let maxTime = this.pickerMinDate + day30
            let minTime = this.pickerMinDate - day30
            return time.getTime() > maxTime || time.getTime() < minTime
          }
        }
      },
      myDepartPer: [], // 选择部门获取到的部门下的人
      mySinglePer: [], // 选择成员中的人
      initPersonArr: [], // 初始化已选择的人id集合
      initDeperArr: [], // 初始化已选择的部门id集合
      allUserInfo: [], // 所有的部门用户信息
      planStatus: 0, // 计划状态
      meansState: '', // 0:新增,1:更新
      editId: '', // 编辑子任务id
      status: '', // 发布状态
      taskList: [], // 子任务列表
      activeName: 'baseInfo',
      navs: [],
      addMeansShow: false,
      baseInfo: {
        // 基础信息
        name: '',
        startTime: '',
        endTime: '',
        date: '',
        executive: '全体成员',
        remarks: ''
      }
    }
  },
  // watch: {
  //   baseInfo: {
  //     handler (val) {
  //       if (this.baseInfo.date) {
  //         let status = Number(this.$route.query.status)
  //         if (status === 0 || status === 1) {
  //           this.compareDate()
  //         }
  //       }
  //     },
  //     deep: true
  //   }
  // },
  created () {
    this.$route.query.showData
      ? (this.activeName = 'census')
      : (this.activeName = 'baseInfo')
    this.initInfo()
    this.getAllUser()
    this.getPlanBaseInfo(this.$route.query.id)
    this.getPlanTaskList(this.$route.query.id)
  },
  methods: {
    showError (errorMsg) {
      this.$message({
        type: 'error',
        showClose: true,
        message: errorMsg
      })
    },
    showSuccess (msg) {
      this.$message({
        type: 'success',
        showClose: true,
        message: msg
      })
    },
    initInfo () {
      // 初始化基本信息
      let status = ['未发布', '未开始', '进行中', '已结束']
      let initNavs = [
        {
          label: '基本信息',
          name: 'baseInfo'
        },
        {
          label: '配置任务',
          name: 'task'
        },
        {
          label: '统计信息',
          name: 'census'
        }
      ]
      this.planStatus = Number(this.$route.query.status)
      this.status = status[this.planStatus]
      if (this.planStatus === 0 || this.planStatus === 1) {
        this.navs = initNavs.slice(0, 2)
      } else {
        this.navs = initNavs
      }
    },
    compareDate () {
      // 处理日期
      if (new Date(this.baseInfo.date[0]).getTime() >= new Date().getTime()) {
        if (this.taskList && this.taskList.length > 0) {
          let minTime = new Date(this.taskList[0].execTime).getTime()
          if (new Date(this.baseInfo.date[0]).getTime() > minTime) {
            this.showError('计划的开始时间不得晚于任务的执行时间')
            this.baseInfo.date = null
          }
        }
        return true
      } else {
        this.showError('开始时间必须大于当下时间,请重新选择')
        this.baseInfo.date = null
      }
      return false
    },
    getStatusTxt (status) {
      let arr = ['未开始', '进行中', '已结束']
      return arr[Number(status)]
    },
    changeDepart (arr) {
      // 部门选择发生变化
      this.myDepartPer = []
      if (arr.length > 0) {
        arr.forEach((item, index) => {
          this.myDepartPer[index] = item
        })
      } else {
        this.myDepartPer = []
      }
    },
    changePerson (arr) {
      // 成员选择发生变化
      let newArr = []
      this.mySinglePer = []
      if (arr && arr.length > 0 && this.allUserInfo.length > 0) {
        this.allUserInfo.forEach((item, index) => {
          arr.forEach((item2, index2) => {
            if (item.id === item2) {
              newArr[index2] = item
            }
          })
          this.mySinglePer = newArr
        })
      } else {
        this.mySinglePer = []
      }
    },
    getTxt (str) {
      let obj = {
        article: '文章',
        form: '表单',
        friend: '朋友圈'
      }
      return obj[str]
    },
    edit (id, info) {
      this.editId = id
      this.meansState = 1
      this.addMeansShow = true
      this.editIndex = Number(info.$index)
      this.selectedId = info.row.materialId
      this.initType = info.row.materialType
      this.taskStartDate = info.row.execTime
    },
    replaceMaketingData (e) {
      let arr = []
      this.taskList.forEach((item, index) => {
        if (this.editIndex === index) {
          arr[index] = e
        } else {
          arr[index] = item
        }
      })
      this.taskList = arr
      this.sort(this.taskList)
    },
    remove (index) {
      this.removeTask(index)
    },
    removeTask (index) {
      this.taskList.splice(index, 1)
    },
    // 添加任务
    addTask () {
      if (this.taskList.length < 10) {
        this.meansState = 0
        this.addMeansShow = true
        this.taskStartDate = '' // 初始化日历
      } else {
        this.showError('配置任务不能超过10条')
      }
    },
    sort (arr) {
      // 数组升序
      var min
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].index) {
          delete arr[i].index
        }
        for (var j = i; j < arr.length; j++) {
          if (
            new Date(arr[i].execTime).getTime() >=
            new Date(arr[j].execTime).getTime()
          ) {
            min = arr[j]
            arr[j] = arr[i]
            arr[i] = min
          }
        }
      }
    },
    addMaketingData (e) {
      let data = {
        status: 0,
        ...e
      }
      // 一次只能push一条数据
      this.taskList.push(data)
      this.sort(this.taskList)
    },
    handleListCancel () {
      this.addMeansShow = false
    },
    async getPlanTaskList () {
      // 获取计划子列表
      const res = await BIZAPIS.MarketingPlanMetaApi.timingPlanMetaGet({
        planId: this.$route.query.id
      })
      if (res.success) {
        this.taskList = res.data.data
      }
    },
    async getPlanBaseInfo (id) {
      // 获取计划基础信息
      this.initPersonArr = []
      this.initDeperArr = []
      const res = await BIZAPIS.MarketingPlanApi.timingPlanGet({
        _id: id,
        planId: this.$route.query.id
      })
      if (res.success) {
        this.showTagsArr = []
        let isAll = res.data.execDepartment.isAll
        let data = res.data
        this.baseInfo.name = data.name
        this.baseInfo.remarks = data.remarks
        this.baseInfo.startTime = data.startTime
        this.baseInfo.endTime = data.endTime
        // this.baseInfo.date = [new Date(data.startTime), new Date(data.endTime)]
        this.baseInfo.date = [data.startTime, data.endTime]
        data.execDepartment.isAll
          ? (this.baseInfo.executive = '全体成员')
          : (this.baseInfo.executive = '指定成员')
        if (data.execDepartment.isAll) {
          this.baseInfo.executive = '全体成员'
        } else {
          if (
            res.data.execDepartment.children &&
            res.data.execDepartment.children.length > 0
          ) {
            let arrD = [] // 部门
            let arrP = [] // 人
            res.data.execDepartment.children.forEach((item, index) => {
              if (item.type === 1) {
                arrD.push(item.name)
              }
              if (item.type === 0) {
                arrP.push(item.name)
              }
            })
            this.showTagsArr = arrD.concat(arrP)
          }
        }
        if (!isAll) {
          let arr = data.execDepartment.children
          arr.forEach((item, index) => {
            if (item.type === 0) {
              this.initPersonArr.push({
                _id: item.id,
                name: item.name
              })
            } else if (item.type === 1) {
              this.initDeperArr.push({
                _id: item.id,
                name: item.name
              })
            }
          })
        }

        let status = Number(this.$route.query.status)
        if (status === 0 || status === 1) {
          this.compareDate()
        }
      }
    },
    async getAllUser () {
      // 获取所有非超管用户信息
      const res = await BIZAPIS.UserApi.timingPlanAllUsersGet({})
      if (res.success) {
        let data = res.data.data
        if (data && data.length > 0) {
          let i = 0
          let len = data.length
          let myData = []
          for (i; i < len; i++) {
            myData[i] = {
              type: 0,
              id: data[i]._id,
              name: data[i].name,
              children: []
            }
          }
          this.allUserInfo = myData
          this.baseInfo.execDepartment = {
            isAll: true,
            children: myData
          }
        }
      }
    },
    check () {
      // 验证信息
      if (this.baseInfo.name === '') {
        this.showError('请输入计划名称')
      } else if (!this.baseInfo.date) {
        this.showError('请选择日期')
      } else if (
        this.baseInfo.executive === '指定成员' &&
        this.myDepartPer &&
        this.myDepartPer.length === 0 &&
        this.mySinglePer &&
        this.mySinglePer.length === 0
      ) {
        this.showError('请添加成员或部门')
      } else if (this.taskList.length === 0) {
        this.showError('请添加配置任务')
      } else {
        return true
      }
      return false
    },
    save (state) {
      // 保存
      if (this.check()) {
        if (this.$route.query.copy) {
        } else {
          this.refresh(state)
        }
      }
    },
    savePublish () {
      // 保存并发布
      this.save(true)
    },
    async refresh (state) {
      if (this.baseInfo.executive === '指定成员') {
        let arr = this.myDepartPer.concat(this.mySinglePer)
        this.baseInfo.execDepartment = {
          isAll: false,
          children: arr
        }
      } else {
        this.baseInfo.execDepartment = {
          isAll: true,
          children: this.allUserInfo
        }
      }
      let arr = []
      this.taskList.forEach((item, index) => {
        arr[index] = {
          execTime: item.execTime,
          materialId: item.materialId,
          materialType: item.materialType
        }
      })
      const res = await BIZAPIS.MarketingPlanApi.timingPlanAllPut({
        _id: this.$route.query.id,
        name: this.baseInfo.name,
        remarks: this.baseInfo.remarks,
        startTime: dayjs(this.baseInfo.date[0]).format('YYYY-MM-DD HH:mm'),
        endTime: dayjs(this.baseInfo.date[1]).format('YYYY-MM-DD HH:mm'),
        execDepartment: this.baseInfo.execDepartment,
        tasks: arr
      })
      if (res.success) {
        this.showSuccess('保存成功')
        if (state === true) {
          this.pubLish()
        }
      }
    },
    async pubLish () {
      // 发布计划
      const res = await BIZAPIS.MarketingPlanApi.timingPlanPatch({
        _id: this.$route.query.id,
        status: 1
      })
      if (res.success) {
        this.showSuccess('发布成功')
        history.go(-1)
      }
    },
    cancel () {
      history.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.plan-detail {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  // /deep/ .el-tabs__nav {
  //   padding: 10px 0;
  // }

  .go-back {
    margin: 10px 0 0 27px;
    display: flex;
    align-items: center;
    color: #595959;
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;

    /deep/ .icon-mk-left {
      color: #595959;
      font-size: 14px;
      margin-right: 3px;
      font-weight: 600;
    }
  }

  /deep/ .el-tabs__item {
    color: #595959;
  }

  /deep/.el-date-editor--datetimerange.el-input__inner {
    width: 320px;
    height: 32px;
  }

  /deep/ .el-input__icon.el-range__icon.el-icon-time {
    line-height: 24px;
  }

  /deep/.el-range-separator {
    line-height: 24px;
  }

  /deep/ .el-date-editor {
    .el-range-input {
      width: 37%;
    }

    .el-range__close-icon {
      line-height: 24px;
    }
  }

  /deep/ .el-radio-button--medium {
    .el-radio-button__inner {
      padding: 8px 16px;
    }
  }

  /deep/ .el-textarea__inner {
    height: 120px;
  }

  .plan-tabs {
    position: relative;

    // /deep/ .el-tabs__nav {
    //   padding: 10px 0;
    // }

    .plan-back {
      position: absolute;
      right: 20px;
      top: 14px;
    }
  }

  .content {
    background: #fff;
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;

    .footer {
      width: 100%;
      height: 60px;
      box-sizing: border-box;
      border-top: 1px solid #d9d9d9;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
      flex-shrink: 0;
    }

    .detail {
      flex: 1;

      .detail-content {
        width: calc(100% - 40px);
        margin: 0 auto;
        margin-top: 20px;
        position: relative;

        .form {
          width: 526px;
        }

        .el-tag {
          font-size: 12px;
          height: 22px;
          line-height: 22px;
        }
      }

      .marketing-data {
        .add-marketing-data {
          display: flex;
          justify-content: flex-end;

          div {
            color: #009cff;
            margin-right: 16px;
            font-size: 14px;
            cursor: pointer;
          }
        }

        .list {
          margin-top: 24px;

          & /deep/ .tag-item {
            padding: 0 8px;
            background-color: #ebeff4;
            color: #6b7b88;
          }

          .tag-group {
            display: flex;

            .tag-item {
              display: block;
              margin-right: 4px;
            }

            .tag-info {
              line-height: 22px;
              margin-left: 4px;
              font-size: 14px;
            }
          }

          .list-no-data {
            width: 92%;
            margin: 0 auto;
            height: 48px;
            border-radius: 8px;
            box-sizing: border-box;
            border: 1px solid #e8e8e8;
            text-align: center;
            line-height: 48px;
            color: #ccc;
          }
        }
      }
    }
  }

  .tips {
    font-size: 13px;
    color: #888;
    line-height: 18px;
    margin-top: 4px;
  }
}
</style>
<style lang="scss">
.tag-popper {
  min-width: unset;
  padding: 10px 0 0 10px;

  .tag-item-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 145px;
    max-height: 300px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 5px;
      background-color: #fff;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: rgba(193, 193, 193, 0.8);
    }

    .tag-item {
      height: 22px;
      padding: 0 8px;
      margin-right: 10px;
      margin-bottom: 10px;
      line-height: 22px;
      background-color: #ebeff4;
      color: #6b7b88;
      border-radius: 2px;
      font-size: 12px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
